import React from "react";

export default function Ellipses() {
  return (
    <div className="ellipses-loader">
      <div />
      <div />
      <div />
    </div>
  );
}
